import { render, staticRenderFns } from "./subSideMenuShrink.vue?vue&type=template&id=78891684"
import script from "./subSideMenuShrink.vue?vue&type=script&lang=js"
export * from "./subSideMenuShrink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports